import { render, staticRenderFns } from "./PatrolModal.vue?vue&type=template&id=24f99fc4&scoped=true"
import script from "./PatrolModal.vue?vue&type=script&lang=js"
export * from "./PatrolModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f99fc4",
  null
  
)

export default component.exports